import React from 'react';
import {
  People as PeopleIcon,
  Description as DescriptionIcon,
  BarChart as BarChartIcon,
  CloudQueue as CloudQueueIcon,
} from '@material-ui/icons';
import { GuarantorsPropertiesText } from 'screens/GuarantorsScreen/components';
import { ru } from 'locale';

export const modalEditedFieldsPipeline = ['limit', 'term', 'comment', 'status'];
export const permissionAccessCategories = ['sbreport'];
export const categoriesUpBlock = [
  {
    id: 'gp',
    label: <GuarantorsPropertiesText />,
    icon: PeopleIcon,
  },
  {
    id: 'sb-report',
    label: ru.reportSb,
    icon: DescriptionIcon,
  },
];
export const categoriesDownBlock = [
  {
    id: 'sd-analytics',
    label: ru.sdAnalytics,
    icon: BarChartIcon,
  },
  {
    id: 'kf-analytics',
    label: ru.kfAnalytics,
    icon: CloudQueueIcon,
  },
];
